import { defineStore } from "pinia";
export const useLayoutStore = defineStore("useLayoutStore", {
  state: () => ({
    loading: { root: false },
    layoutType: "vertical",
    layoutWidth: "fluid",
    sidebarSize: "lg",
    topbar: "light",
    mode: "light",
    position: "fixed",
    sidebarView: "default",
    sidebarColor: "dark",
    sidebarImage: "none",
    preloader: "disabled",
    visibility: "show",
    menu: null,
  }),
  getters: {
    getLoading(state) {
      return state.loading;
    },
    getMenu(state) {
      return state.menu;
    },
    getLayout(state) {
      return state;
    },
  },
  actions: {
    addLoadingSpin(parentDiv) {
      if (!parentDiv.querySelector(".elmLoader")) {
        var elmLoader = document.createElement("div");

        elmLoader.className = "elmLoader";
        var spinner = document.createElement("div");
        spinner.className = "spinner-border text-primary avatar-sm";
        spinner.role = "status";
        var span = document.createElement("span");
        span.className = "visually-hidden";
        span.textContent = "Loading...";
        spinner.appendChild(span);
        elmLoader.appendChild(spinner);
        parentDiv.appendChild(elmLoader);
      }
    },
    toggleLoading(elm) {
      if (elm) {
        this.addLoadingSpin(elm);
        if (elm.getAttribute("data-load") == undefined) {
          elm.style = "position:relative";
          elm.setAttribute(
            "data-load",
            (Math.random() + 1).toString(36).substring(7)
          );
        }
        if (this.loading[elm.getAttribute("data-load")] == undefined) {
          this.loading[elm.getAttribute("data-load")] = false;
        }
        this.loading[elm.getAttribute("data-load")] =
          !this.loading[elm.getAttribute("data-load")];
      } else {
        this.loading["root"] = !this.loading["root"];
      }
    },
    SET_MENU(menu) {
      this.menu = menu;
    },
    CHANGE_LAYOUT(layoutType) {
      this.layoutType = layoutType;
    },
    CHANGE_LAYOUT_WIDTH(layoutWidth) {
      this.layoutWidth = layoutWidth;
    },
    CHANGE_SIDEBAR_TYPE(sidebarSize) {
      this.sidebarSize = sidebarSize;
    },
    CHANGE_TOPBAR(topbar) {
      this.topbar = topbar;
    },
    CHANGE_MODE(mode) {
      this.mode = mode;
    },
    CHANGE_POSITION(position) {
      this.position = position;
    },
    CHANGE_SIDEBAR_VIEW(sidebarView) {
      this.sidebarView = sidebarView;
    },
    CHANGE_SIDEBAR_COLOR(sidebarColor) {
      this.sidebarColor = sidebarColor;
    },
    CHANGE_SIDEBAR_IMAGE(sidebarImage) {
      this.sidebarImage = sidebarImage;
    },
    CHANGE_PRELOADER(preloader) {
      this.preloader = preloader;
    },
    CHANGE_VISIBILITY(visibility) {
      this.visibility = visibility;
    },
    changeLayoutType(layoutType) {
      this.CHANGE_LAYOUT(layoutType);
      document.body.removeAttribute("style");
    },
    changeLayoutWidth(layoutWidth) {
      this.CHANGE_LAYOUT_WIDTH(layoutWidth);
    },
    changeSidebarSize(sidebarSize) {
      this.CHANGE_SIDEBAR_TYPE(sidebarSize);
    },
    changeTopbar(topbar) {
      this.CHANGE_TOPBAR(topbar);
    },
    changeMode(mode) {
      this.CHANGE_MODE(mode);
    },
    changePosition(position) {
      this.CHANGE_POSITION(position);
    },
    changeSidebarView(sidebarView) {
      this.CHANGE_SIDEBAR_VIEW(sidebarView);
    },
    changeSidebarColor(sidebarColor) {
      this.CHANGE_SIDEBAR_COLOR(sidebarColor);
    },
    changeSidebarImage(sidebarImage) {
      this.CHANGE_SIDEBAR_IMAGE(sidebarImage);
    },
    changePreloader(preloader) {
      this.CHANGE_PRELOADER(preloader);
    },
    changeVisibility(visibility) {
      this.CHANGE_VISIBILITY(visibility);
    },
    getLayoutMenu() {
      return this.menu;
    },
  },
});
